import React, { useEffect, useState } from "react";
import { AvForm } from "availity-reactstrap-validation";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { Card, CardBody, Col, Container, Button, Row, Label, Form, CardImg } from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";
import Dropzone from "react-dropzone"
import Select from "react-select";
import moment from "moment";
import { Link } from "react-router-dom";
import { FaPen , FaRegTrashAlt, FaPlus, FaCloudUploadAlt} from "react-icons/fa";


const AddService = (props) => {
  const statusOptions = [
    { value: "Y", label: "Enable" },
    { value: "N", label: "Disable" },
  ];

  const ServiceTypeOptions = [
    { label: "Makan Master", value: "makan-master" },
    { label: "End of Trip", value: "endoftrip" },
    { label: "Events", value: "events" },
    { label: "Facilities", value: "facilities" },
  ];


  const [serviceType, setServiceType] = useState(ServiceTypeOptions[0].value);
  const [imageUrl, setImageUrl] = useState();
  const [sort, setSort] = useState();
  const [status, setStatus] = useState(statusOptions[0].value);
  const [visibility, setVisibility] = useState(false);
  const [successAlert, setSuccesAlert] = useState(false);
  const [errorAlert, setErrorAlert] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [token, setToken] = useState();
  const [propsData, setPropsData] = useState(props?.location?.state);
  const [selectedFiles,setSelectedFiles]=useState([])

  useEffect(() => {
    const token = localStorage.getItem("AuthenticationToken");
    setToken(token);

    if (props.location.state?.edit) {
      setPropsData(props?.location?.state);
      
      let visibility=props.location.state?.item?.visibility ;
      var serviceType = props.location.state?.item?.service_type;
      var imageUrl = props.location.state?.item?.image_url;
      var sort = props.location.state?.item?.sort_order;
      var status = props.location.state?.item?.item_status;

      setServiceType(serviceType);
      setVisibility(visibility)
      setImageUrl(imageUrl);
      setSort(sort);
      setStatus(status);
    }
  }, []);

  const handleSubmit = () => {
    if (!serviceType) {
      setErrorMessage("Please Select Service Type");
      setErrorAlert(true);
      return;
    } else if (!status) {
      setErrorMessage("Please Select Status");
      setErrorAlert(true);
      return;
    }
    else if (!sort) {
      setErrorMessage("Please Enter Position");
      setErrorAlert(true);
      return;
    }
    let currentDate = moment(new Date()).format("YYYY/MM/DD HH:mm");
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append("cache-control", "no-cache");
    myHeaders.append(
      "Cookie",
      "__cfduid=d5b74235daa6f013fde0aba762ec288811620640208"
    );

    var formdata = new FormData();
    formdata.append("path", "services/add");
    formdata.append("created_datetime", currentDate);
    formdata.append("service_type", serviceType);
    formdata.append("visibility",visibility ? 1 : 0);
    formdata.append("userfile", selectedFiles[0], selectedFiles[0].path);
    formdata.append("item_type", "services");
    formdata.append("sort_order", sort);
    formdata.append("item_status", status);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
      processData: false,
      mimeType: "multipart/form-data",
      async: true,
      crossDomain: true,
    };

    fetch(`${process.env.REACT_APP_TOKRI_API_URL}/api/frhub`, requestOptions)
      .then((response) => {
        if (response.status == 200) {
          console.log("here is the res", response);
          setSuccesAlert(true);
        } else {
          setErrorMessage("Unable to Add");
          setErrorAlert(true);
        }
        response.json();
        console.log("here is the res", response);
      })
      .catch((error) => {
        console.log("here come error--->", error);
      });
  };

  const handleEdit = () => {
    if (!serviceType) {
      setErrorMessage("Please Select Service Type");
      setErrorAlert(true);
      return;
    } else if (!status) {
      setErrorMessage("Please Select Status");
      setErrorAlert(true);
      return;
    }
    else if (!sort) {
      setErrorMessage("Please Enter Position");
      setErrorAlert(true);
      return;
    }
    // let currentDate = moment(new Date()).format("YYYY/MM/DD HH:mm")
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append("cache-control", "no-cache");
    myHeaders.append(
      "Cookie",
      "__cfduid=d5b74235daa6f013fde0aba762ec288811620640208"
    );

    var formdata = new FormData();
    formdata.append("item_id", propsData?.item?.item_id);
    formdata.append("path", "services/update");
    formdata.append("service_type", serviceType);
    formdata.append("visibility",visibility ? 1 : 0);
    if(!imageUrl){formdata.append("userfile", selectedFiles[0], selectedFiles[0].path);}
    formdata.append("item_type", "services");
    formdata.append("sort_order", sort);
    formdata.append("item_status", status);
    // formdata.append("image_url",imageUrl);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
      processData: false,
      mimeType: "multipart/form-data",
      async: true,
      crossDomain: true,
    };

    fetch(`${process.env.REACT_APP_TOKRI_API_URL}/api/frhub`, requestOptions)
      .then((response) => {
        if (response.status == 200) {
          console.log("here is the res", response);
          setSuccesAlert(true);
        } else {
          setErrorMessage("Unable to Add");
          setErrorAlert(true);
        }
        console.log("here is the res", response);
      })
      .catch((error) => {
        console.log("here come error--->", error);
      });
  };

  const renderSuccessAlert = () => {
    return (
      <SweetAlert
        title="Success!"
        success
        confirmBtnBsStyle="success"
        onConfirm={() => {
          props?.history.push("/services");
          setSuccesAlert(false);
        }}
        onCancel={() => {
          setSuccesAlert(false);
        }}
      >
        {props?.location?.state?.edit?"Service Updated Successfully":"Service Added Successfully"}
      </SweetAlert>
    );
  };

  const renderFailureAlert = () => {
    return (
      <SweetAlert
        title="Warning!"
        warning
        confirmBtnBsStyle="warning"
        onConfirm={() => {
          setErrorAlert(false);
        }}
      >
        {errorMessage ? errorMessage : "Error. Something went wrong."}
      </SweetAlert>
    );
  };

    /**
   * Formats the size
   */
     function formatBytes(bytes, decimals = 2) {
      if (bytes === 0) return "0 Bytes"
      const k = 1024
      const dm = decimals < 0 ? 0 : decimals
      const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
  
      const i = Math.floor(Math.log(bytes) / Math.log(k))
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
    }

  function handleAcceptedFiles(files) {
    files.map(file =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      })
    )
    let path = files[0].path
    path = path.split(".")
    path = path[1]
    if (path == "jpg"  || path == "JPG"  || path=="png" || path=="PNG") {
      setSelectedFiles(files)
      setImageUrl("")
    } else {
      setErrorMessage("Please select a .jpg or .png file")
      setErrorAlert(true)
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs breadcrumbItem="Add Service" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <AvForm className="needs-validation">
                    <Card>
                      <CardBody>
                        <Row>
                        <Col lg={4} md={6} sm={6}>
                            <div className="mb-3">
                              <Label>Position</Label>
                              <div className="col-md-12">
                                <input
                                  className="form-control"
                                  onChange={(e) => {
                                    setSort(e.target.value);
                                  }}
                                  type="number"
                                  id="sort_input"
                                  defaultValue={sort}
                                />
                                {/* <small className="text-muted user-select-none">
                                  For mobile app only
                                </small> */}
                              </div>
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={4} md={10} sm={10}>
                            <div className="mb-3">
                              <Label>Select Service Type</Label>
                              <Select
                                isSearchable={false}
                                onChange={(e) => {
                                  setServiceType(e.value);
                                }}
                                placeholder={
                                  serviceType
                                    ? ServiceTypeOptions.map((item) => {
                                        if (item.value == serviceType) {
                                          return item.label;
                                        }
                                      })
                                    : "choose.."
                                }
                                defaultValue={serviceType}
                                options={ServiceTypeOptions}
                                maxMenuHeight={120}
                                menuPlacement="auto"
                                required
                              />
                            </div>
                          </Col>
                          <Col lg={2} md={2} sm={6} style={{ paddingTop: 38, paddingLeft:'6%' }}>
                            <div className="form-check form-switch">
                              <input
                                type="checkbox"
                                className="form-check-input checkbox"
                                id="visibility"
                                value={visibility}
                                defaultChecked={props?.location?.state?.item?.visibility}
                                onChange={() => {
                                  setVisibility(!visibility);
                                }}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="visibility"
                              >
                                Visibility
                              </label>
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={12} md={12} sm={12}>
                          <Card>
                                  <CardBody>
                                    <Form
                                     >
                                     {imageUrl &&
                                        <Row>
                                          <Col lg={4}>
                                            <CardImg className="img-fluid" src={imageUrl}
                                              style={{ marginBottom: 15, width: "500px" }}
                                              alt="" />
                                          </Col>
                                          <Col>
                                            <div style={{cursor:"pointer"}} className="px-3 text-danger"
                                              onClick={() => {
                                                setImageUrl("")
                                              }}
                                            ><FaRegTrashAlt /> Move To Trash</div>
                                          </Col>
                                        </Row>}
                                      <Dropzone
                                        onDrop={acceptedFiles => {
                                          // validateFileSize(acceptedFiles)
                                          handleAcceptedFiles(acceptedFiles)
                                        }}
                                        
                                      >
                                        {({ getRootProps, getInputProps }) => (
                                          <div className="dropzone" >
                                            <div
                                              className="dz-message needsclick"
                                              {...getRootProps()}
                                            >
                                              <input {...getInputProps()} />
                                              <div className="mb-3">
                                                <FaCloudUploadAlt className="display-4 text-muted"/>
                                              </div>
                                              <h4>Drop files here or click to upload.</h4>
                                                       
                                              <p style={{ fontSize: 12, color: "red" }}>
                                                </p>
                                            </div>
                                          </div>
                                        )}
                                      </Dropzone>
                                      <div className="dropzone-previews mt-3" id="file-previews">
                                        {selectedFiles.map((f, i) => {
                                          return (
                                            <Card
                                              className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                              key={i + "-file"}
                                            >
                                              <div className="p-2">
                                                <Row className="align-items-center">
                                                  <Col className="col-auto">
                                                    <img
                                                      data-dz-thumbnail=""
                                                      height="80"
                                                      className="avatar-sm rounded bg-light"
                                                      alt={f.name}
                                                      src={f.preview}
                                                    />
                                                  </Col>
                                                  <Col>
                                                    <Link
                                                      to="#"
                                                      className="text-muted font-weight-bold"
                                                    >
                                                      {f.name}
                                                    </Link>
                                                    <p className="mb-0">
                                                      <strong>{f.formattedSize}</strong>
                                                    </p>
                                                  </Col>
                                                </Row>
                                              </div>
                                            </Card>
                                          )
                                        })}
                                      </div>
                                    </Form>
                                  </CardBody>
                                </Card>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                    <Card>
                      <CardBody>
                        <Row>
                          <Col lg={4} md={6} sm={6}>
                            <div className="mb-3">
                              <Label>Status</Label>
                              <Select
                                isSearchable={true}
                                // value={selectedStatus}
                                onChange={(e) => {
                                  setStatus(e.value);
                                }}
                                options={statusOptions}
                                placeholder={
                                  status
                                    ? status == "Y"
                                      ? "Enable"
                                      : "Disable"
                                    : "Choose..."
                                }
                                defaultValue={status}
                                required
                              />
                            </div>
                          </Col>
                          <Col lg={1}></Col>
                        </Row>
                      </CardBody>
                    </Card>
                    <div style={{ textAlign: "right" }} className="btn-sec">
                      <Button
                        onClick={() => {
                          props.history.push("/services");
                        }}
                        color="danger"
                        type="submit"
                      >
                        {" "}
                        Cancel
                      </Button>
                      <Button
                        onClick={() => {
                          if (props?.location?.state?.edit) {
                            handleEdit();
                          } else {
                            handleSubmit();
                          }
                        }}
                        style={{ marginLeft: "10px" }}
                        // className="px-4"
                        color="success"
                        type="submit"
                      >
                        Save
                      </Button>
                    </div>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {successAlert ? renderSuccessAlert() : null}
          {errorAlert ? renderFailureAlert() : null}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default AddService;
